import { useState } from "react";
import { Formik } from "formik";
import { Grid, TextField, FormLabel } from "@mui/material";
import { ModalFooter } from "../../../../components/common/Modal/ModalFooter";

export const SectionPrices: React.FC<any> = (props): JSX.Element | any => {

    const { dataPrices, setDataPrices, currentSection, handlePrevSection, handleNextSection, sections, clearState, productSelected, closeModal, listproducts, onSubmit, loadingsave } = props;

    const validateForm = (values) => {
        let errors:any = {};
        if(!values.cost) errors.cost = "el campo es requerido";
        if(!values.price) errors.price = "el campo es requerido";
        // if(!values.alternativeprice) errors.alternativeprice = "el campo es requerido";
        // if(!values.margin) errors.margin = "el campo es requerido";
        // if(!values.offerprice) errors.offerprice = "el campo es requerido";
        return errors;
    }

    const handleKeyDown = (event) => {
        const keyCode = event.keyCode || event.which;
        if (keyCode === 189 || keyCode === 109) {
          event.preventDefault();
        }
    };

    const saveProducts = async(values)  => {
        onSubmit && onSubmit(values)
    }

    const onCancel = () => {
        handlePrevSection && handlePrevSection();
    }

    return (
        <Grid sx={{height:'100%', position: 'relative'}}>
            <Formik initialValues={dataPrices} enableReinitialize validate={ (values) => validateForm(values) } onSubmit={saveProducts}>
                {({values, errors, touched, handleSubmit, handleChange, setFieldValue}) => {
                    return (
                        <form onSubmit={handleSubmit}>
                            <Grid container sx={{maxHeight: '65vh', overflowY: 'scroll', paddingRight:'5px'}}>
                                <Grid item container xs={12} spacing={2}>
                                    <Grid item xs={12} md={6}>
                                        <FormLabel>Costo:</FormLabel>
                                        <TextField
                                            id="cost"
                                            type="number" 
                                            name="cost"
                                            fullWidth
                                            size="small"
                                            value={values.cost}
                                            onChange={handleChange}
                                            error={errors.cost && touched.cost ? true : false}
                                            onKeyDown={handleKeyDown}
                                            InputProps={{
                                                inputProps: {
                                                    min: 1
                                                }
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <FormLabel>Precio del producto:</FormLabel>
                                        <TextField
                                            id="price"
                                            type="number" 
                                            name="price"
                                            fullWidth
                                            size="small"
                                            value={values.price}
                                            onChange={handleChange}
                                            error={errors.price && touched.price ? true : false}
                                            onKeyDown={handleKeyDown}
                                            InputProps={{
                                                inputProps: {
                                                    min: 1
                                                }
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <FormLabel>Precio alternativo:</FormLabel>
                                        <TextField
                                            id="alternativeprice"
                                            type="number" 
                                            name="alternativeprice"
                                            fullWidth
                                            size="small"
                                            value={values.alternativeprice}
                                            onChange={handleChange}
                                            error={errors.alternativeprice && touched.alternativeprice ? true : false}
                                            onKeyDown={handleKeyDown}
                                            InputProps={{
                                                inputProps: {
                                                    min: 1
                                                }
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <FormLabel>Margen:</FormLabel>
                                        <TextField
                                            id="margin"
                                            type="number" 
                                            name="margin"
                                            fullWidth
                                            size="small"
                                            value={values.margin}
                                            onChange={handleChange}
                                            error={errors.margin && touched.margin ? true : false}
                                            onKeyDown={handleKeyDown}
                                            InputProps={{
                                                inputProps: {
                                                    min: 1
                                                }
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <FormLabel>Precio de oferta:</FormLabel>
                                        <TextField
                                            id="offerprice"
                                            type="number" 
                                            name="offerprice"
                                            fullWidth
                                            size="small"
                                            value={values.offerprice}
                                            onChange={handleChange}
                                            error={errors.offerprice && touched.offerprice ? true : false}
                                            onKeyDown={handleKeyDown}
                                            InputProps={{
                                                inputProps: {
                                                    min: 1
                                                }
                                            }}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                            <div style={{ position: 'absolute', bottom: 0, width: '100%' }}>
                                <ModalFooter 
                                    buttonType="submit"
                                    confirmText={'Guardar producto'}
                                    onConfirm={handleSubmit}
                                    cancelText={"Atrás"}
                                    onCancel={onCancel}
                                    loading={loadingsave}
                                />
                            </div>
                        </form>
                    )
                }} 
            </Formik>
        </Grid>
    )
}